import ConstantList from "app/appConfig";
import { getFormData } from "app/common/LocalFunction";
import axios from "axios";

const API_PATH = ConstantList.API_EN_POINT + "/excel";

export const importStaffRevenueExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-excel-product-revenue-allocation";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importStaffExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-staff";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importStaffKPIExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-staff-department-kpi";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importServiceExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-service";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};
export const importServiceFeeExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-fee";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importFileExcelBed = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-hospital-bed";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importConceptExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-concept";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};
export const importExcelConceptIndicator = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-indicator";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};
export const importConceptFormExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-concept-form";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importDepartmentExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-department-ex";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importQuantityUnit = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-quantity-unit";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelOrganization = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-organization";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelMedical = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-medical-equipment";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelMedicalEquipmentType = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-medical-equipment-type";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelServiceRequest = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-request-set";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelHealthCareRoom = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-health-care-room";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelPatientTypeService = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-patient-type-service";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelDepartment = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-department-ex";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelPatientType = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-patient-type";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelPatientGroup = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-patient-group";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelPatientRank = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-patient-rank";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelVAT = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-vat";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelServiceStep = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-step";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelServiceGroup = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-group";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelServiceRoom = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-room";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelCostNorm = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-cost-norm";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelClienrCard = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-client-card";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelClienrCardFee = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-client-card-fee";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelClienrCardScope = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-client-card-scope";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelClienrCardRevenueAllocation = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-client-card-revenue-allocation";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelRevenueAllocation = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-excel-revenue-allocation";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const downloadClientCard = () => {
  let url = API_PATH + "/download-excel-client-card";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadClientCardFee = () => {
  let url = API_PATH + "/download-template-client-card-fee";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadClientCardScope = () => {
  let url = API_PATH + "/download-excel-client-card-scope";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadClientCardRevenueAllocation = () => {
  let url = API_PATH + "/download-excel-client-card-revenue-allocation";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateDepartment = () => {
  let url = API_PATH + "/download-template-department";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateHealthCareRoom = () => {
  let url = API_PATH + "/download-template-health-care-room";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateHospitalBed = () => {
  let url = API_PATH + "/download-template-hospital-bed";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateServiceGroup = () => {
  let url = API_PATH + "/download-template-service-group";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateServiceRequestSet = () => {
  let url = API_PATH + "/download-template-service-request-set";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateCustomerSourceGroup = () => {
  let url = API_PATH + "/download-template-customer-source-group";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateCustomerSource = () => {
  let url = API_PATH + "/download-template-customer-source";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplatePatientTypeService = () => {
  let url = API_PATH + "/download-excel-patient-type-service";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplatePatientGroup = () => {
  let url = API_PATH + "/download-excel-patient-group";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplatePatientType = () => {
  let url = API_PATH + "/download-excel-patient-type";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplatePatientRank = () => {
  let url = API_PATH + "/download-excel-patient-rank";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateMedicalEquipment = () => {
  let url = API_PATH + "/download-excel-medical-equipment";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateMedicalEquipmentType = () => {
  let url = API_PATH + "/download-excel-medical-equipment-type";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadVAT = () => {
  let url = API_PATH + "/download-excel-service-vat";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadService = () => {
  let url = API_PATH + "/download-excel-service-step";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadCostNorm = () => {
  let url = API_PATH + "/download-excel-cost-norm";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateServiceFee = () => {
  let url = API_PATH + "/download-template-service-fee";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateServiceRoom = () => {
  let url = API_PATH + "/download-template-service-room";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const importExcelPosition = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-position";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const importExcelServiceDepartment = (file) => {
  let formData = getFormData({ upload: file });

  let url = API_PATH + "/import-service-department";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const downloadTemplatePosition = () => {
  let url = API_PATH + "/download-template-position";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateOrganization = () => {
  let url = API_PATH + "/download-template-organization";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateServiceDepartment = () => {
  let url = API_PATH + "/download-template-service-department";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadRevenueAllocation = () => {
  let url = API_PATH + "/download-template-service-revenue-allocation";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const importClientCardScope = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-client-card-scope";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const downloadTemplateStaff = () => {
  let url = API_PATH + "/download-template-staff";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};
export const downloadRevenueTemplateStaff = () => {
  let url = API_PATH + "/download-template-product-revenue-allocation";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadTemplateStaffKPI = () => {
  let url = API_PATH + "/download-staff-department-kpi-template";
  return axios({
    url: url,
    method: "GET",
    responseType: "blob",
  });
};
export const importServiceWarrantyExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH + "/import-warranty-period";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};
